<script>
    import { CheckCell, Loading } from '@oat-sa-private/ui-components';
    import { Icon } from '@oat-sa-private/ui-elements';

    export let data;
</script>

<style>
    .warning {
        color: var(--color-text-warning);
    }
</style>

{#if data.spinner}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div class="custom wrapper loading" on:click={evt => evt.stopPropagation()}>
        <Loading size="smallest" />
    </div>
{:else if data.warning}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div class="custom wrapper loading warning" on:click={evt => evt.stopPropagation()}>
        <Icon name="warning-16" />
    </div>
{:else}
    <CheckCell bind:data on:action />
{/if}
